import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoTrim: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVideoTrim"><Path d="M15.5 2.5V4.5M15.5 4.5V19.5M15.5 4.5H2.5V19.5H15.5M15.5 19.5V21.5M18.5 19.5H21.5V4.5H18.5M7.5 9.5V14.5L11 12L7.5 9.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVideoTrim;
